module.exports = __webpack_public_path__ + "static/fonts/DMSans-Bold.234ee18d.woff2";